const NavigationArrowRight = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
  <rect opacity="0.01" width="24" height="24" fill="none" fill-opacity="0.01"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.29291L6.58579 3.70712L14.8779 12L6.58579 20.2929L8 21.7071L17.7071 12L8 2.29291Z" fill="currentColor"/>
  </svg>
    `;
export default NavigationArrowRight;
